import encryptFieldJP from "./utils/encryptFieldJP";

export default async function bookDemoFnJP(fields: Record<string, string>) {
  const entries = await Promise.all(
    Object.entries(fields)
      .filter(([, value]) => Boolean(value))
      .map(async ([key, value]) => [key, await encryptFieldJP(value)]),
  );

  const response = await fetch(
    `${process.env.REACT_APP_API_URL_BOOKDEMO_JP}/book-demo`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY_BOOKDEMO_JP || "",
      },
      body: JSON.stringify(Object.fromEntries(entries)),
    },
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok || data.success !== true)
    throw new Error(data.error || "Network response was not ok");

  return data;
}
